
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';
import ListProducts from './ListProducts';
import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';

import ScotchScreen from './SCOTCH';
import IrishScreen from './IRISH';
    import RyeScreen from './RYE';
import BourbonScreen from './BOURBON';
import TennesseeScreen from './TENNESSEE';


function Index({dishs2, setShowListProduct2, goHome}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const [menus, setMenus] = useState([]);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showMezal, setShowMezal] = useState(false);
    const [showTequila, setShowTequila] = useState(false);
    const [showWhiskey, setshowWhiskey] = useState(false);
    const [showVodka, setshowVodka] = useState(false);
    const [showGin, setShowGin] = useState(false);
    const [showRum, setShowRum] = useState(false);
    const [showCognac, setShowCognac] = useState(false);
    const [showAppetif, setShowAppetif] = useState(false);
    const [showPisco, setshowPisco] = useState(false);
    const [showScotch, setshowScotch] = useState(false);
    const [showIrish, setshowIrish] = useState(false);
    const [showRye, setshowRye] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [showBourbon, setshowBourbon] = useState(false);
    const [showTennessee, setshowTennessee] = useState(false);
    const [datachampana, setdatachampana] = useState(false);
    const [datawine, setdatawine] = useState(false);

     useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
     }, []);
    
    
    useEffect(() => {
        menus.map((item) => {
            if (item.id === 341) {
                setdatachampana(item);
            }
            if (item.id === 340) {
                setdatawine(item);
            }
        });
    }, [menus]);
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowListProduct={setShowListProduct2} setShowSpecials={setShowSpecials} goHome={goHome}>
                <div style={{ padding: '0 20px', }}>
                    <img
                         onContextMenu={(e) => e.preventDefault()}
                        src={require('./assets/top.png')}
                        style={{
                        objectFit: 'contain',
                        width: '100%',
                            height: 140,
                          pointerEvents: 'none',
                        marginTop: -10,
                        }}
                    />
                     <p style={{color: 'white', textAlign: 'center', fontSize: 35, marginTop: 100}}>
                        WHISKEY
                    </p>
                    <div
                        
                        style={{
                            display: 'flex',
                            marginTop: 10,
                            flexDirection: 'row',
                            alignSelf: 'center',
                            justifyContent: "center"
                        }}>
                        <div
                            onClick={()=>setshowScotch(true)}
                            style={{
                            display: 'flex',
                            justifyContent: 'center',
                                alignItems: 'center',
                            position: 'relative'
                        }}>
                            <img
                                  onContextMenu={(e) => e.preventDefault()}
                                src={require('./assets/bk.png')}
                                style={{
                                    objectFit: 'contain',
                                    width: 200,
                                    height: 120,
                                     pointerEvents: 'none',
                                }}
                            />
                            <div style={{position: 'absolute'}}>
                                <p
                                    style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                    SCOTCH
                                </p>
                            </div>
                        </div>

                        <div
                           onClick={()=>setshowIrish(true)}
                            style={{
                                 display: 'flex',
                            justifyContent: 'center',
                                alignItems: 'center',
                            position: 'relative'
                            }}>
                            <img
                                 onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/bk.png')}
                            style={{
                                resizeMode: 'contain',
                                width: 200,
                                height: 120,
                                 pointerEvents: 'none',
                            }}
                            />
                            <div style={{position: 'absolute'}}>
                                <p
                                    style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                    IRISH
                                </p>
                            </div>
                        </div>
                    </div>

                    <div
                        style={{
                            display:'flex',
                            flexDirection: 'row',
                            alignSelf: 'center',
                            justifyContent: 'center'
                        }}>
                        <div
                             onClick={()=>setshowRye(true)}
                            style={{
                                display: 'flex',
                                position: 'relative',
                            justifyContent: 'center',
                            alignItems: 'center',
                            }}>
                            <img
                                 onContextMenu={(e) => e.preventDefault()}
                                src={require('./assets/bk.png')}
                                style={{
                                    resizeMode: 'contain',
                                    width: 200,
                                    height: 120,
                                     pointerEvents: 'none',
                            }}
                            />
                            <div style={{position: 'absolute'}}>
                                <p
                                    style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                    RYE
                                </p>
                            </div>
                        </div>

                        <div
                             onClick={()=>setshowBourbon(true)}
                            style={{
                                display: 'flex',
                                position: 'relative',
                            justifyContent: 'center',
                            alignItems: 'center',
                            }}>
                            <img
                                 onContextMenu={(e) => e.preventDefault()}
                                src={require('./assets/bk.png')}
                                style={{
                                    resizeMode: 'contain',
                                    width: 200,
                                    height: 120,
                                     pointerEvents: 'none',
                            }}
                            />
                            <div style={{position: 'absolute'}}>
                                <p
                                    style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                    BOURBON
                                </p>
                            </div>
                        </div>

                        
                    </div>

                    <div
                        
                        style={{
                            display: 'flex',
                            marginTop: 10,
                            flexDirection: 'row',
                            alignSelf: 'center',
                            justifyContent: "center"
                        }}>
                            <div
                             onClick={()=>setshowTennessee(true)}
                            style={{
                                 display:'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}>
                            <img
                                src={require('./assets/bk.png')}
                                style={{
                                    resizeMode: 'contain',
                                    width: 200,
                                    height: 120,
                                }}
                            />
                            <div style={{position: 'absolute'}}>
                            <p
                                style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                TENNESSEE
                            </p>
                            </div>
                        </div>
                        </div>
                    
                    
                </div>
                
                {showSpecials && <SpecialsScreen setShowHappy={goHome} setShowListProduct={setShowSpecials}  />}
               
                {showScotch && <ScotchScreen setShowListProduct={setshowScotch} goHome={goHome} />}
                {showIrish && <IrishScreen setShowListProduct={setshowIrish} goHome={goHome} />}
                {showRye && <RyeScreen setShowListProduct={setshowRye} goHome={goHome} />}
                {showBourbon && <BourbonScreen setShowListProduct={setshowBourbon} goHome={goHome} />}
                {showTennessee && <TennesseeScreen setShowListProduct={setshowTennessee} goHome={goHome} />}
                    {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={false}
                />}
                
            </LayoutContent>
        </div>
    );
}
export default Index;